import { FC } from 'react';

import LoadingSpinnerComponent from '../LoadingSpinnerComponent';

const LoadingSpinnerVariantsComponent: FC = () => {
    return (
        <div className="br-variantsLoading">
            <LoadingSpinnerComponent />
        </div>
    );
};

export default LoadingSpinnerVariantsComponent;
